import { ConfirmDialog } from '@/components/ConfirmDialog';
import { fontFamilies, s } from '@/theme/tokens';
import { Stack, Text } from '@/ui';
import { Box } from '@/ui/primitives';
import type { ReactElement } from 'react';

type DeleteTestDialogProps = {
  open: boolean;
  testName?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DeleteTestDialog = ({
  open,
  testName,
  loading = false,
  onClose,
  onConfirm,
}: DeleteTestDialogProps): ReactElement => {
  const resolvedTestName = testName?.trim() ?? 'this test';
  const testNameCodeSx = {
    display: 'inline',
    fontFamily: fontFamilies.mono,
    backgroundColor: 'action.hover',
    borderRadius: s('xxs'),
    pl: s('sm'),
    pr: s('xs'),
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    boxDecorationBreak: 'clone',
  } as const;

  return (
    <ConfirmDialog
      open={open}
      title="Confirm Delete"
      description={
        <Stack gap="md">
          <Text role="body" color="textSecondary">
            Are you sure you want to delete test{' '}
            <Box component="code" sx={testNameCodeSx}>
              {resolvedTestName}
            </Box>
            ?
          </Text>
          <Text role="body" color="textSecondary">
            This action will also delete all test executions associated with this test.
          </Text>
        </Stack>
      }
      confirmLabel="Delete Test"
      confirmColor="red"
      loading={loading}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
